import { render, staticRenderFns } from "./CompanyInfobase.vue?vue&type=template&id=5c8548f8&scoped=true"
import script from "./CompanyInfobase.vue?vue&type=script&lang=js"
export * from "./CompanyInfobase.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfobase.vue?vue&type=style&index=0&id=5c8548f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8548f8",
  null
  
)

export default component.exports